import { Grid, Icon, Input, InputOnChangeData, Popup } from "semantic-ui-react";

type IPv4SettingsProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
  value: string;
};

const IPv4Settings = ({ onChange, value }: IPv4SettingsProps) => {
  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <h5>
          CIDR
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left-10"
              />
            }
          >
            A valid value will look like 10.Current_Region_ID.0.0/24. If no
            value provided, the default will be set for you
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-top-30"
      >
        <Input
          value={value}
          name="cidr"
          className="select-box full"
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};

export default IPv4Settings;
